// extracted by mini-css-extract-plugin
export var dropdown = "_ur-0";
export var imageWrapper = "_ur-3";
export var itemNameContainer = "_ur-1";
export var productImage = "_ur-2";
export var spinnerWrapper = "_ur-4";